import React, {
  useEffect,
  useLayoutEffect,
  useState,
  useContext,
  Fragment,
} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Button } from 'react-bootstrap';
import { CSVLink, CSVDownload } from 'react-csv';
import Assignee from 'components/sales/formSection/assignee/assignee';
import './style.css';

const PreSalesListing = ({
  perSalesList = null,
  getPreSaleListing = null,
  statusList = null,
  dealStatusList = null,
  getStatusList = null,
  UpdateLeadStatus = null,
  updateDealStatus = null,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
  getAssignee,
  assign,
  postBulkAssignment = null,
}) => {
  const Headers = [
    'Number',
    'Business',
    'Building',
    'Category',
    'Status',
    'Deal Status',
    'Created By',
    'Owner',
    'Creation On',
    'Last Contact Date',
    'Followup',
    'Change Status',
    'Action',
  ];
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [activePostSales, setActivePostSales] = useState();
  const [status, setStatus] = useState();
  const [deal_status, setDealStatus] = useState();
  const [activePreSales, setActivePreSales] = useState('');
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [isRoleId, setIsRoleId] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [bulkAssignment, setBulkAssignment] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [bulkAssignmentData, setBulkAssignmentData] = useState('');
  const [successBulk, setSuccessBulk] = useState(false);

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem('roles'));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);

  const onBulkAssignment = (data, checked) => {
    if (checked && data !== undefined && data !== null) {
      bulkAssignment.push(data);
      setBulkAssignment([...bulkAssignment]);
    } else if (!checked && data !== undefined && data !== null) {
      const isThere = bulkAssignment.findIndex((obj) => obj === data);
      bulkAssignment.splice(isThere, 1);
      setBulkAssignment([...bulkAssignment]);
    }
    let newData = listData.filter((val, i) => {
      return bulkAssignment.includes(val.id);
    });
    setCsvData(newData);
  };

  const createLead = async () => {
    if (departmentId && departmentId === 2) {
      if (teamId && teamId === 7) {
        setActivePreSales('add-gate');
      } else if (teamId && teamId === 9) {
        setActivePreSales('preSalesSupply');
      } else if (teamId && teamId === 8) {
        setActivePreSales('add-gate');
      } else {
        setActivePreSales('pre-sales-b2b-alliance');
      }
    }
  };
  const createLeadPost = async () => {
    if (departmentId && departmentId === 2) {
      if (teamId && teamId === 7) {
        setActivePostSales('post-sales-corporate');
      } else if (teamId && teamId === 9) {
        setActivePostSales('post-sales-supply');
      } else if (teamId && teamId === 8) {
        setActivePostSales('post-sales-apartment');
      } else {
        setActivePostSales('post-sales-b2b-alliance');
      }
    }
  };

  useLayoutEffect(() => {
    localStorage.setItem('postSales', JSON.stringify(false));
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useLayoutEffect(() => {
    if (teamId && departmentId) {
      createLead();
      createLeadPost();
      
    }
  }, [teamId, departmentId]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  /*-------Will be add separately-------*/

  const headerBtns = () => {
    return (
      <Fragment>
        <div className="lead-filter">
        <Button
          onClick={filterToggle}
          className="filter-hamburger filter-btn btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>

        {csvData && csvData.length > 0 && (
          <CSVLink
            data={csvData}
            filename={'Presales-Listing.csv'}
            className="btn export-btn btn-primary"
          >
            {localization.exportList}
          </CSVLink>
        )}

        {bulkAssignment && bulkAssignment.length > 0 && (
          <Button
            onClick={() => {
              setOpenModal(true);
            }}
          >
            {localization.bulkAssignment}
          </Button>
        )}
        </div>
      </Fragment>
    );
  };

  const sumbitBulk = async () => {
    if (bulkAssignmentData !== null && bulkAssignmentData.user_id !== '') {
      setIsLoading(true);
      const res = await postBulkAssignment(bulkAssignmentData);
      setIsLoading(false);
      if (res) {
        setOpenModal(false);
        setSuccessBulk(true);
        (async () => {
          setIsLoading(true);
          await getPreSaleListing(null, 1);
          setIsLoading(false);
        })();
      }
    }
  };

  useEffect(() => {
    if (getPreSaleListing !== null) {
      (async () => {
        setIsLoading(true);
        await getPreSaleListing(null, 1);
        setIsLoading(false);
      })();
    }
    if (getStatusList !== null) (async () => await getStatusList())();
  }, [getPreSaleListing, getStatusList]);

  useEffect(() => {
    (async () => {
      await getListFilterData(1);
    })();
  }, []);

  useEffect(() => {
    const tableData = [
      'id', 
      'lead_no',
      'client_name',
      'building_name',
      'lead_category',
      'status',
      'deal_name',
      'created_by',
      'assigned_to',
      'created_at',
      'last_call_date',
      'next_action_date',
      
    ];

    const actions1 = [
      { name: 'Edit Details', link: `${baseUrl}/edit-details` },
      { name: 'Change Assignee', link: `${baseUrl}/assignee` },
    ];

    const actions = [
      { name: 'View Details', link: `${baseUrl}/view-details` },
      { name: 'Edit Details', link: `${baseUrl}/edit-details` },
      { name: 'Follow Up', link: `${baseUrl}/followUp` },
      { name: 'View POC', link: `${baseUrl}/viewPoc` },
      // {
      //   name: localization.presaleData,
      //   link: `${baseUrl}/${activePreSales && activePreSales}`,
      // },
      {
        name: 'Add Contract',
        link: `/dashboard/${activePostSales && activePostSales}`,
      },
      { name: 'Change Assignee', link: `${baseUrl}/assignee` },
    ];

    if (perSalesList !== {} && perSalesList.resultSets) {
      setIsLoading(true);
      const data = perSalesList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            'Change Status': '',
            Action: element['lead_no'] === 0 ? actions1 : actions,
          }
        )
      );

      if (bulkAssignment.length === 0) {
        const csvFiledData = perSalesList.resultSets.map((element) =>
          Object.assign(
            {},
            ...tableData.map((key) => ({ [key]: element[key] }))
          )
        );
        csvFiledData && setCsvData(csvFiledData);
      }

      data && setListData(data);
      setPageCount(Math.ceil(perSalesList.total / perSalesList.per_page));
      setIsLoading(false);
    }
    setStatus(statusList);
  }, [
    baseUrl,
    perSalesList,
    statusList,
    activePreSales,
    bulkAssignment.length,
  ]);

  const updateLeadStatus = async (data) => {
    const selectedData = await statusList.filter(
      (obj) => obj.name === data.status
    );
    if (data.status && selectedData.length) {
      const requestData = {
        lead_id: data.lead_id,
        status: selectedData[0].id,
      };
      await UpdateLeadStatus(requestData).then(async (response) => {
        if (response) {
          setIsLoading(true);
          await getPreSaleListing(null, 1);
          setIsLoading(false);
          setIsStatusSuccess(true);
        }
      });
    }
  };
// console.log(dealStatusList);

  // const updateDealStatus = async (data) => {
  //   const selectedData = await dealStatusList.filter(
  //     (obj) => obj.name === data.status
  //   );
  //   if (data.status && selectedData.length) {
  //     const requestData = {
  //       lead_id: data.lead_id,
  //       status: selectedData[0].id,
  //     };
  //     await UpdateDealStatus(requestData).then(async (response) => {
  //       if (response) {
  //         setIsLoading(true);
  //         await getPreSaleListing(null, 1);
  //         setIsLoading(false);
  //         setIsStatusSuccess(true);
  //       }
  //     });
  //   }
  // };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getPreSaleListing(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getPreSaleListing(filter, val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      if (getAssignee) {
        setIsLoading(true);
        await getAssignee(bulkAssignment[0]);
        setIsLoading(false);
      }
    })();
  }, []);

  return (
    <Layout
      title={localization.preSalesLeadListing}
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      <TableSection
        data={listData}
        headers={Headers}
        isId={false}
        status={status}
        deal_status={deal_status}
        onChange={(data) => updateLeadStatus(data)}
        onChangeBulk={(data, checked) => onBulkAssignment(data, checked)}
        detailList={perSalesList && perSalesList.resultSets}
        pageCount={pageCount}
        onPageChange={onPageChange}
        isBulkAssign={true}
        srNo={perSalesList?.from}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        getZones={(val) => getZones(val)}
        statusId={'1,2,3'}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        isRoleId={isRoleId}
        filterPreSalesListing
      />
      <ModalPop
        title={localization.updatedSuccessfully}
        show={isStatusSuccess}
        handleModalHide={closeSuccess}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadStatusupdatedsuccessfully}</h5>
          <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
            {localization.continue}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.bulkAssignment}
        show={openModal}
        handleModalHide={() => {
          setOpenModal(false);
        }}
      >
        <div className="text-center">
          <Assignee
            isBulkAssignment={true}
            assigneeList={assign}
            leadId={bulkAssignment}
            handleValue={(data) => {
              setBulkAssignmentData(data);
            }}
          />
          <Button onClick={() => sumbitBulk()}>{localization.submit}</Button>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.updatedSuccessfully}
        show={successBulk}
        handleModalHide={() => setSuccessBulk(false)}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.updatedSuccessfully}</h5>
          <Link
            to="#"
            onClick={() => setSuccessBulk(false)}
            className="btn btn-transparent"
          >
            {localization.continue}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default PreSalesListing;
